import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';

const json = {

  1: { // Exercise num
    unit: 'Unit 3',
    id: 'WB4-V2-U3-P24-E1',
    audio: '',
    video: '',
    component: UI,
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page24/E1/1.jpg' },
      ],
    ]
  },
  2: { // Exercise num
    unit: 'Unit 3',
    id: 'WB4-V2-U3-P23-E2',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 5,
    isAllowSubmit: true,
    exerciseKey: 'img/FriendsPlus/Page24/E2/Key/Key.PNG',
    titleImage: '',
    questionImage: [ // Row

      [
        // Column 1
        { url: 'img/FriendsPlus/Page24/E2/1.jpg' },
      ],
      [
        // Column 1
        { url: 'img/FriendsPlus/Page24/E2/38.jpg' },
      ],
      [
        // Column 1
        { url: 'img/FriendsPlus/Page24/E2/1a.jpg' },
      ],
      [
        // Column 1
        { url: 'img/FriendsPlus/Page24/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/3.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page24/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/5.jpg', input: 1, isCorrect: false },
        { url: 'img/FriendsPlus/Page24/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/7.jpg' },

      ],
      [
        // Column 1
        { url: 'img/FriendsPlus/Page24/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/9.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page24/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/11.jpg', input: 2, isCorrect: false },
        { url: 'img/FriendsPlus/Page24/E2/12.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/13.jpg' },
      ],
      [
        // Column 2

        { url: 'img/FriendsPlus/Page24/E2/14.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/15.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page24/E2/16.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/17.jpg', input: 3, isCorrect: false },
        { url: 'img/FriendsPlus/Page24/E2/18.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/19.jpg' },
      ],
      [
        // Column 1
        { url: 'img/FriendsPlus/Page24/E2/20.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/21.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/22.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/23.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/24.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/25.jpg' },
      ],
      [
        // Column 2
        { url: 'img/FriendsPlus/Page24/E2/26.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/27.jpg', input: 5, isCorrect: false },
        { url: 'img/FriendsPlus/Page24/E2/28.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/29.jpg', input: 5, isCorrect: true },
        { url: 'img/FriendsPlus/Page24/E2/30.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/31.jpg' },
      ],
      [
        // Column 1
        { url: 'img/FriendsPlus/Page24/E2/32.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/33.jpg', input: 6, isCorrect: false },
        { url: 'img/FriendsPlus/Page24/E2/34.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/35.jpg', input: 6, isCorrect: true },
        { url: 'img/FriendsPlus/Page24/E2/36.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/37.jpg' },
      ],
      [
        // Column 1
        { url: 'img/FriendsPlus/Page24/E2/37.jpg' },
      ],
    ],
  },
  3: { // Exercise num
    unit: 'Unit 3',
    id: 'WB4-V2-U3-P24-E3',
    audio: '',
    video: '',
    maxLength: 3,
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page24/E3/Key/Key.PNG',
    questionImage: [ // Row

      [
        // Column1
        { url: 'img/FriendsPlus/Page24/E3/1.jpg' },
      ],
      [
        // Column 1
        { url: 'img/FriendsPlus/Page24/E2/38.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page24/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page24/E3/3.jpg', input: true, answer: "Yes" },
        { url: 'img/FriendsPlus/Page24/E3/4.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page24/E3/5.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page24/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page24/E3/7.jpg', input: true, answer: "No" },
        { url: 'img/FriendsPlus/Page24/E3/8.jpg' },
        { url: 'img/FriendsPlus/Page24/E3/9.jpg', input: true, answer: "No" },
        { url: 'img/FriendsPlus/Page24/E3/10.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page24/E3/11.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page24/E3/12.jpg' },
        { url: 'img/FriendsPlus/Page24/E3/13.jpg', input: true, answer: "Yes" },
        { url: 'img/FriendsPlus/Page24/E3/14.jpg' },
        { url: 'img/FriendsPlus/Page24/E3/15.jpg', input: true, answer: "Yes" },
        { url: 'img/FriendsPlus/Page24/E3/16.jpg' },
      ],
    ],
  },





}

export default json;